import { ProductSection } from 'components/ProductSection';
import { EditorialMostPopularProductsBlock } from 'models/EditorialMostPopularProductsBlock';
import { rm } from 'utils';
import { ProductlistViewProduct } from 'models/ProductlistViewProduct';
import { useDispatch } from 'react-redux';
import { GtmSelectItem, GtmViewListItem } from 'store/googleTagManager/actions';
import {
  getEditorialProductListName,
  mapProductListViewProductToGtm
} from 'store/googleTagManager/events/utils';
import { useIntersectionObserver } from 'hooks';
import { TrackedElement } from 'hooks/useIntersectionObserver';

export const MostPopularProducts = ({
  hasCustomHeadline,
  products,
  title = ''
}: EditorialMostPopularProductsBlock) => {
  const reduxDispatch = useDispatch();
  const headline = hasCustomHeadline ? title : rm('header_most_popular_box', title);
  const handleOnProductClick = (product: ProductlistViewProduct, index: number) => {
    const listName = getEditorialProductListName(headline);
    const gtmItemProduct = mapProductListViewProductToGtm({
      product,
      indexInList: index,
      listName
    });

    reduxDispatch(GtmSelectItem({ gtmItemProduct }));
  };

  const { setElementRef } = useIntersectionObserver({
    onBatchVisible: handleElementsVisible
  });

  function handleElementsVisible(elements: TrackedElement<ProductlistViewProduct>[]) {
    const items = elements.map(element => {
      const viewedProduct = element.payload;
      const productIndex = products.indexOf(viewedProduct);
      const listName = getEditorialProductListName(headline);

      return mapProductListViewProductToGtm({
        product: viewedProduct,
        indexInList: productIndex,
        listName
      });
    });

    reduxDispatch(GtmViewListItem({ gtmItemProducts: items }));
  }

  return (
    <ProductSection
      title={headline}
      products={products}
      onClick={handleOnProductClick}
      setIntersectObserverRef={setElementRef}
    />
  );
};
